export const leave_report_data = [
  {
    key: "1",
    admissionNo: "AD9892434",
    student_name: "Janet",
    rollNo: "35013",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "2",
    admissionNo: "AD9892433",
    student_name: "Joann",
    rollNo: "35012",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "3",
    admissionNo: "AD9892432",
    student_name: "Kathleen",
    rollNo: "35011",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "4",
    admissionNo: "AD9892431",
    student_name: "Gifford",
    rollNo: "35010",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "5",
    admissionNo: "AD9892430",
    student_name: "Lisa",
    rollNo: "35009",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "6",
    admissionNo: "AD9892429",
    student_name: "Ralph",
    rollNo: "35008",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "7",
    admissionNo: "AD9892428",
    student_name: "Julie",
    rollNo: "35007",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "8",
    admissionNo: "AD9892427",
    student_name: "Ryan",
    rollNo: "35006",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "9",
    admissionNo: "AD9892426",
    student_name: "Susan",
    rollNo: "35004",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
  {
    key: "10",
    admissionNo: "AD9892425",
    student_name: "Richard",
    rollNo: "35003",
    avatar: "https://imageplaceholder.net/300",
    medicalUsed: 2,
    medicalAvailable: 8,
    casualUsed: 4,
    casualAvailable: 8,
    maternityUsed: 0,
    maternityAvailable: 10,
    paternityUsed: 0,
    paternityAvailable: 10,
    specialUsed: 0,
    specialAvailable: 10,
  },
];
